import {
  Vector3,
  Quaternion,
  Camera
} from "three";
import { Hotspot } from "threngine";
import { Hotspot3D } from "./Hotspot3D";

// opacity reimplementation
// this is necessary because the threngine code doesn't account for the overall scene rotation.
// See: https://gitlab.com/viscircle-org/shell/threngine/-/blob/master/src/core/configuration/hotspotHandler.ts#L123

const getAngle = (a:Vector3, b:Vector3, cutoff:number):number => {
  let dot = a.dot(b.multiplyScalar(-1));
  let angle = (0.5 * dot) + 0.5;
  let viewAngle = Math.min( Math.max(1, cutoff), 360 );

  viewAngle = viewAngle / 720;
  angle -= (1 - viewAngle);
  
  if (angle < 0) return 0.0;
  
  let value = angle / viewAngle;

  value = 1 - value;
  value *= value;
  value = 1 - value;        
  return value;
};

const getDistance = (a:Vector3, b:Vector3, cutoff:number):number => {  
  cutoff = Math.max(0.01, cutoff);
  
  let distance = a.distanceTo(b)
  
  if (distance > cutoff) return 0.0;
  
  let value = 1 - (distance / cutoff);
  
  value = 1 - value;
  value *= value;
  value = 1 - value;
  return value;
}

export const getOpacity = (
  hotspot:Hotspot,
  hotspot3D:Hotspot3D,
  camera:Camera,
  worldRotation:Quaternion
) => {
  const {angle, distance, direction, ignoreAngle, ignoreDistance} = hotspot;

  if (ignoreAngle && ignoreDistance) return 1;

  const h_dir = new Vector3().fromArray(direction).applyQuaternion(worldRotation);
  const c_dir = camera.getWorldDirection(new Vector3());

  // TODO: do not reallocate a vector every time...
  const h_pos = new Vector3().setFromMatrixPosition(hotspot3D.matrixWorld);
  const c_pos = camera.position.clone();

  let a = ignoreAngle ? 1 : getAngle(h_dir, c_dir, angle);
  let d = ignoreDistance ? 1 : getDistance(h_pos, c_pos, distance);

  const aroundZero = (x:number) => {
    const eps = 0.01;
    return Math.abs(x) - eps < 0;
  };

  if (aroundZero(a) || aroundZero(d)) return 0;

  let opacity = 0.5 * (a + d);

  return opacity;
};